'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: 'development',
  SUB_ENV: 'develop',
  VUE_APP_DOC_TITLE_PREFIX: 'MW-local',
  VUE_APP_MW_DOC: 'https://coda.io/d/Model-Waste_drBCmwwRkMb',
  VUE_APP_DEV_BACKEND_HOST: 'https://dev.mw.big3.ru/',
  VUE_APP_FLOW_ANIMATION: false,
  VUE_APP_FLOW_SHOW_ITEMS: false,
  VUE_APP_SHOW_B3_GIS: true
})



//////////////////
// WEBPACK FOOTER
// ./config/local.env.js
// module id = Snpf
// module chunks = 40